// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_main_content_sections_sections_module_ts":"2b7de42ebcd618d5","node_modules_xlsx_dist_xlsx_mini_min_js":"4405a12c80486127","node_modules_xlsx_xlsx_js":"b0366956a47df5a2"}[chunkId] + ".js";
};